// extracted by mini-css-extract-plugin
module.exports = {"inlineAd":"zO","innerWrapper":"AO","tooltipWrapper":"BO","icon":"CO","tooltip":"DO","content":"EO"};